module.exports = __webpack_public_path__ + "static/img/wCnNn1qw.0ef5000.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cabins/horse-nest/wCnNn1qw.jpg
// module id = eZig
// module chunks = 7